import React, { useState, useContext, useEffect } from "react";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import clsx from "clsx";
import { StoreContext } from "../../../Store/Provider";
import { makeStyles } from "@material-ui/core/styles";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import Header from "../Home/Header/Header";
import Drawer from "@material-ui/core/Drawer";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Sidebar from "../Home/Sidebar/Sidebar";
import InquiryForm from "./InquiryForm";
import ScheduleForm from "./ScheduleForm";

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

function Schedule(props) {
  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const [alertText, setAlertText] = useState("");
  const context = useContext(StoreContext);
  const [value, setValue] = React.useState(0);
  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  console.log(props);
  return (
    <div className="home">
      <Snackbar
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        open={open}
        autoHideDuration={3000}
        onClose={handleClose}
      >
        <Alert severity="error" onClose={handleClose}>
          {alertText}
        </Alert>
      </Snackbar>
      <Header />
      <div className="shipmentsListingHome">
        <Drawer
          variant="persistent"
          className={clsx(classes.drawerLeft, {
            [classes.drawerOpen]: context.menuBar,
            [classes.drawerClose]: !context.menuBar,
          })}
          classes={{
            paper: clsx(classes.drawerPaperleft, {
              [classes.drawerOpen]: context.menuBar,
              [classes.drawerClose]: !context.menuBar,
            }),
          }}
        >
          <Sidebar />
        </Drawer>
        <main className={clsx(classes.content)}>
          <div className="scheduleSearchPageScreen ">
            <div className="container">
              <Tabs
                value={value}
                onChange={handleChange}
                TabIndicatorProps={{
                  style: { background: "rgba(var(--text-heading-light))" },
                }}
              >
                <Tab label="General Enquiry" className="TourthirdStep" />
                {context.isUserLogin ? (
                  <Tab label="Request Quote" className="TourfourthStep" />
                ) : null}
              </Tabs>
              {value === 0 ? <InquiryForm /> : <ScheduleForm />}
            </div>
          </div>
        </main>
      </div>
    </div>
  );
}

const useStyles = makeStyles((theme) => ({
  content: {
    flexGrow: 1,
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  drawerLeft: {
    width: "18%",
    flexShrink: 0,
    whiteSpace: "nowrap",
  },
  drawerPaperleft: {
    top: "auto",
    height: "calc(100% - 3rem)",
    visibility: "visible !important",
    transform: "translateX(0px) !important",
  },
  drawerOpen: {
    width: "18%",
    minWidth: "16rem",
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerClose: {
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: "hidden",
    width: "2.5rem",
  },
}));

export default Schedule;
